import * as React from "react";
import Home from "../containers/Home";

const IndexPage = () => {
  return <Home />;
};

export default IndexPage;
